<template>
  <b-modal
    id="airport-rates-dialog"
    ref="modal"
    :title="$t('rate.airport-rates')"
    :ok-disabled="adding"
    :cancel-disabled="adding"
    :hide-header-close="adding"
    :no-close-on-backdrop="adding"
    :no-close-on-esc="adding"
    size="lg"
    centered
  >
    <b-card v-if="adding" :header="$t('general.add_new')">
      <airport-rate-form
        :vehicle-id="vehicleId"
        @saved="onCreated"
        @cancelled="adding = false"
      />
    </b-card>
    <b-button
      v-if="!adding"
      variant="light"
      class="mb-2"
      @click="adding = !adding"
    >
      {{ $t('general.add_new') }}
    </b-button>
    <admin-table
      ref="table"
      :api-builder="apiBuilder"
      :columns="columns"
      :row-actions="['details', 'delete']"
      :bulk-actions="[]"
    >
      <template slot="price" slot-scope="{ item }">
        <value-price-with-currency :item="{priceInBaseCurrency: item.price}"  attribute="price"/>
      </template>

      <template slot="row-details" slot-scope="{ item }">
        <airport-rate-form
          :vehicle-id="vehicleId"
          :id="item.id"
          @saved="onUpdated"
          @cancelled="item._showDetails = false"
        />
      </template>
    </admin-table>
  </b-modal>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import VehicleZonePriceForm from './Form'
import AirportRateForm from './Form'
import AirportRatesApi from './Api'
import ValuePriceWithCurrency from "../../components/values/ValuePriceWithCurrency";

export default {
  name: 'AirportRate',

  components: {
    AdminTable,
    VehicleZonePriceForm,
    AirportRateForm,
    ValuePriceWithCurrency,
  },

  props: {
    vehicleId: { type: [Number, String], required: true },
  },

  data: () => ({
    adding: false,
  }),

  computed: {
    columns() {
      return [
        {
          key: 'zone.name',
          label: this.$t('rate.fields.zone_name'),
        },
        {
          key: 'airport.name',
          label: this.$t('rate.fields.airport_name'),
        },
        {
          key: 'direction_label',
          label: this.$t('rate.fields.direction'),
        },
        {
          key: 'price',
          label: this.$t('rate.fields.price'),
        },
      ]
    },
  },

  methods: {
    apiBuilder() {
      return new AirportRatesApi(this.vehicleId)
    },
    onCreated() {
      this.adding = false
      this.$refs.table.refresh()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
  },
}
</script>
